import { ContentLayout } from '@nohara-dxdev/react-core';
import { UserOnboardingCheck, OrgSelectCheck } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';
import { Outlet, useRouteError } from 'react-router';

import { OrgLayout } from '@/components/layouts';
import { paths } from '@/config/paths';

import NotFoundRoute from '../not-found';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return (
    <OrgLayout>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </OrgLayout>
  );
};

const OrgRoot = () => {
  return (
    <UserOnboardingCheck onboardingPath={paths.onboarding.getHref()}>
      <OrgSelectCheck
        ignorePaths={[paths.onboarding.getHref(), paths.org.userProfile.getHref()]}
        getOrgPath={paths.org.dashboard.getHref}
        Layout={OrgLayout}
        fallbackElement={<NotFoundRoute />}
      >
        <Outlet />
      </OrgSelectCheck>
    </UserOnboardingCheck>
  );
};

export default OrgRoot;
